var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceReactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 22C17.8562 22 22.3334 17.5228 22.3334 12C22.3334 6.47715 17.8562 2 12.3334 2C6.81053 2 2.33337 6.47715 2.33337 12C2.33337 17.5228 6.81053 22 12.3334 22Z",
    stroke: "#F6A723",
    strokeWidth: 1.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 15C9.24549 16.2144 10.6977 17 12.3334 17C13.9691 17 15.4213 16.2144 16.3334 15",
    stroke: "#F6A723",
    strokeWidth: 1.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34234 9H8.33337M16.3334 9H16.3244",
    stroke: "#F6A723",
    strokeWidth: 1.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceReactions);
export default __webpack_public_path__ + "static/media/performance-reactions.133142c6c27fdd85e2d8644a55bbf94e.svg";
export { ForwardRef as ReactComponent };